var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPremiumActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22C9.4 22 9 21.5 9 21V20H15V21C15 21.5 14.6 22 14 22H10ZM5 9C5 5.1 8.1 2 12 2C15.9 2 19 5.1 19 9C19 11.3 17.8 13.4 16 14.7V17C16 17.5 15.6 18 15 18H9C8.4 18 8 17.5 8 17V14.7C6.2 13.5 5 11.4 5 9ZM13.5733 8.02959L12.7523 5.04491H11.3119L10.4294 8.02959H13.5733ZM6.68262 8.71529L11.8832 15.9645L8.9782 8.71529H6.68262ZM12.1762 15.9643L15.0813 8.71529H17.3826L12.1762 15.9643ZM13.6245 8.71527H10.3761L12.0004 14.4054L13.6245 8.71527ZM6.65918 8.02965L8.75813 5.17079C8.79109 5.13139 8.83228 5.0997 8.87882 5.07795C8.92536 5.05621 8.9761 5.04494 9.02746 5.04494H10.5187L9.00098 8.02965H6.65918ZM17.3708 8.02965L15.3019 5.17079C15.269 5.13139 15.2278 5.0997 15.1813 5.07795C15.1347 5.05621 15.084 5.04494 15.0326 5.04494H13.5415L15.0592 8.02965H17.3708Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DC6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#97CB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumActive);
export default __webpack_public_path__ + "static/media/PremiumActive.94ad148a06d2439bf804bcaae546d981.svg";
export { ForwardRef as ReactComponent };